import * as types from './actionTypes';
import {apiRequest} from '../utils/request';
import {toastr} from 'react-redux-toastr';

export function loadDriversSuccess(drivers){
  return {type: types.LOAD_DRIVERS_SUCCESS, drivers};
}

export function loadDrivers() {
  return function (dispatch) {
    dispatch(loadDriversSuccess({loaded: false, items: []}));
    return apiRequest(`/api/drivers`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching drivers, error: ${x.error ? x.error : x.data.Message}`);
          dispatch(loadDriversSuccess({loaded: true, items: []}));
        } else {
          dispatch(loadDriversSuccess({loaded: true, items: Array.from(x.data)}));
        }
      });
  };
}
